module.exports = __webpack_public_path__ + "static/media/homeIcon.6f760199.svg";